import { useState, useEffect } from 'react';
import { heroImages, logoUrl } from '@/mocks/homeData';

export default function HeroSection() {
  const [currentBg, setCurrentBg] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBg((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
    <section id="top" className="relative min-h-[600px] md:min-h-[800px] flex items-center justify-center overflow-hidden">
      <a href="#top" className="absolute left-4 top-4 z-20">
        <img src={logoUrl} alt="GF골 로고" className="h-24 md:h-36 w-auto" />
      </a>
      {heroImages.map((img, i) => (
        <div key={i} className={`absolute inset-0 transition-opacity duration-1000 ${currentBg === i ? 'opacity-100' : 'opacity-0'}`}>
          <img src={img.src} alt={img.alt} className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40" />
        </div>
      ))}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-6 leading-tight">
          천안 신방동에서 만나는 쾌적한 실내연습장
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a href="https://www.instagram.com/gf_golf_cheonan/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-full hover:bg-white/20 transition whitespace-nowrap">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-instagram-line text-lg" />
            </div>
            <span className="text-lg md:text-xl font-medium">GF 실내연습장 인스타그램</span>
          </a>
          <a href="https://www.instagram.com/y_0216__/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-full hover:bg-white/20 transition whitespace-nowrap">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-instagram-line text-lg" />
            </div>
            <span className="text-lg md:text-xl font-medium">윤혜민 프로  인스타그램</span>
          </a>
        </div>
      </div>
    </section>
    </>
  );
}